import template from 'text!./ContactRoleNamedInsured.html';
import controller from './ContactRoleNamedInsuredCtrl';

export default {
    controller,
    template,
    bindings: {
        roleType: '@',
        roleModel: '<',
        contactType: '@'
    }
}; 
